module.exports = __webpack_public_path__ + "img/arrow-right.a487765b.svg";